import { GatsbyLinkProps, Link } from "gatsby";
import React, { ReactNode } from "react";
import { useGetCurrentSearch } from "./LinkAsButton";
import { Arrow } from "./Navbar";
import { useTracking } from "./tracking/trackUser";

export const TrackedLink = ({ ref, to, ...props }: GatsbyLinkProps<any>) => {
    const { track } = useTracking();
    const search = useGetCurrentSearch();
    return (
        <Link
            onClick={(e) => {
                track({
                    type: "Interaction",
                    page: window.location.pathname,
                    name: `Clicked link`,
                    properties: {
                        linkTo: to,
                        external: false,
                    },
                });
            }}
            to={`${to}${search}`}
            {...props}
        />
    );
};

export const TrackedLinkAsButton = ({
    to,
    ref,
    arrowDirection = "right",
    preserveSearch = true,
    ...props
}: {
    children: ReactNode;
    className?: string;
    noArrow?: boolean;
    preserveSearch?: boolean;
    arrowDirection?: "right" | "left";
    to: string;
} & GatsbyLinkProps<any>) => {
    const { track } = useTracking();
    const search = useGetCurrentSearch();
    return (
        <Link
            {...props}
            onClick={(e) => {
                track({
                    type: "Interaction",
                    page: window.location.pathname,
                    name: `Clicked link`,
                    properties: {
                        linkTo: to,
                        external: false,
                    },
                });
            }}
            to={`${to}${preserveSearch ? search : ""}`}
            className={`font-medium w-fit group/arrow flex whitespace-nowrap items-center rounded-full py-1.5 px-4 text-sm transition-all ${props.className}`}
        >
            {!props.noArrow && arrowDirection === "left" && <Arrow flip />}
            {props.children}
            {!props.noArrow && arrowDirection === "right" && <Arrow />}
        </Link>
    );
};

export const TrackedExternalLink = ({
    ref,
    href,
    children,
    ...props
}: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>) => {
    const { track } = useTracking();
    const search = useGetCurrentSearch();
    return (
        <a
            onClick={() =>
                track({
                    type: "Interaction",
                    page: window.location.pathname,
                    name: `Clicked link`,
                    properties: {
                        linkTo: href,
                        external: true,
                    },
                })
            }
            href={`${href}${search}`}
            {...props}
        >
            {children}
        </a>
    );
};
